import { gql } from '@apollo/client';

export const CREATE_FILE_FOR_METRIC_RECORD_MUTATOR = gql`
  mutation CreateFileForMetricRecordMutator(
    $group_id: String
    $company_id: String
    $file_name: String
    $metric_record_id: String
    $file_path: String
    $user_email: String
  ) {
    createFile(
      group_id: $group_id
      company_id: $company_id
      file_name: $file_name
      metric_record_id: $metric_record_id
      file_path: $file_path
      user_email: $user_email
    )
  }
`;

export const DELETE_FILE_FOR_METRIC_RECORD_MUTATOR = gql`
  mutation DeleteFileForMetricRecordMutator(
    $group_id: String
    $company_id: String
    $file: JSON
    $user_email: String
  ) {
    deleteFile(group_id: $group_id, company_id: $company_id, file: $file, user_email: $user_email)
  }
`;
